import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'srcReact/components/common2/Button'
import Modal from 'srcReact/components/common2/Modal'
import ManageMembers from '../ManageMembers'
import styles from './styles.module.scss'

const ChooseAdminOnLeave = ({ closeModal }) => {
  const { t } = useTranslation()

  const [openManageMembers, setOpenManageMembers] = useState(false)

  const closeAndOpenManageMembers = () => {
    setOpenManageMembers(true)
  }
  const closeManageMembers = () => {
    setOpenManageMembers(false)
    closeModal()
  }

  return (
    <React.Fragment>
      <h1 className={styles.title}>{t('messenger.header.leaveConversationErrorTitle')}</h1>
      <div className={styles.buttonWrapperOK}>
        <Button size='large' text={t('messenger.btnOK')} handleClick={closeAndOpenManageMembers} />
      </div>

      <Modal nested={true} isOpen={openManageMembers} handleClose={closeManageMembers} closeOnDocumentClick={false}>
        <ManageMembers closeModal={closeManageMembers} />
      </Modal>
    </React.Fragment>
  )
}

export default ChooseAdminOnLeave
